export enum blogTypes {
    FETCH_BLOGS_REQUEST = 'FETCH_BLOGS_REQUEST',
    FETCH_BLOG_BY_ID = 'FETCH_BLOG_BY_ID',
    CREATE_BLOGS_REQUEST = 'CREATE_BLOGS_REQUEST',
    EDIT_BLOG_REQUEST = 'EDIT_BLOG_REQUEST',
    DELETE_BLOG_REQUEST = 'DELETE_BLOG_REQUEST',
    SET_BLOGS = 'SET_BLOGS',
    SET_BLOG = 'SET_BLOG',
    SET_RELATIVE = 'SET_REALTIVE',
}

export enum newsTypes {
    FETCH_NEWS_REQUEST = 'FETCH_NEWS_REQUEST',
    FETCH_NEWS_BY_ID = 'FETCH_NEWS_BY_ID',
    CREATE_NEWS_REQUEST = 'CREATE_NEWS_REQUEST',
    EDIT_NEWS_REQUEST = 'EDIT_NEWS_REQUEST',
    DELETE_NEWS_REQUEST = 'DELETE_NEWS_REQUEST',
    SET_NEWS = 'SET_NEWS',
    SET_ONE_PIECE_OF_NEWS = 'SET_ONE_PIECE_OF_NEWS',
    SET_RELATIVE = 'SET_REALTIVE',
}
